import { useStoreWithEqualityFn } from 'zustand/traditional';
import {
  selectHasSaveVpcSheetBack,
  selectIsCantOpenDesignModalVisible,
  selectIsLoadVpcSheetVisible,
  selectIsLoadVpcSheetVisibleOnExit,
  selectIsOpenDesignSheetOpen,
  selectIsOpenDesignSheetVisibleOnExit,
  selectIsSaveAsDesignToProfileSheetOpen,
  selectIsSaveDesignToProfileSheetOpen,
  selectIsShareDesignCardOpen,
  selectIsShowSavedDesignsTabEnabled,
  selectIsVpcSheetOpen,
  selectOpenDesignActiveTab,
  selectSaveVpcSheetOpenedFromPrint
} from './selectors';
import { designStore } from './store';
import type { DesignState } from './types';

const useDesignStore = <T>(
  selector: (state: DesignState) => T,
  equalityFn: (left: T, right: T) => boolean = Object.is
) => useStoreWithEqualityFn(designStore, selector, equalityFn);

export const useIsVpcSheetOpen = () => useDesignStore(selectIsVpcSheetOpen);
export const useIsLoadVpcSheetVisible = () => useDesignStore(selectIsLoadVpcSheetVisible);
export const useIsLoadVpcSheetVisibleOnExit = () =>
  useDesignStore(selectIsLoadVpcSheetVisibleOnExit);
export const useSaveVpcSheetOpenedFromPrint = () =>
  useDesignStore(selectSaveVpcSheetOpenedFromPrint);
export const useHasSaveVpcSheetBack = () => useDesignStore(selectHasSaveVpcSheetBack);
export const useIsCantOpenDesignModalVisible = () =>
  useDesignStore(selectIsCantOpenDesignModalVisible);
export const useIsSaveDesignToProfileSheetOpen = () =>
  useDesignStore(selectIsSaveDesignToProfileSheetOpen);
export const useIsSaveAsDesignToProfileSheetOpen = () =>
  useDesignStore(selectIsSaveAsDesignToProfileSheetOpen);
export const useIsShareDesignCardOpen = () => useDesignStore(selectIsShareDesignCardOpen);
export const useIsOpenDesignSheetOpen = () => useDesignStore(selectIsOpenDesignSheetOpen);
export const useIsShowSavedDesignsTabEnabled = () =>
  useDesignStore(selectIsShowSavedDesignsTabEnabled);
export const useIsOpenDesignSheetVisibleOnExit = () =>
  useDesignStore(selectIsOpenDesignSheetVisibleOnExit);
export const useOpenDesignActiveTab = () => useDesignStore(selectOpenDesignActiveTab);
